// extracted by css-extract-rspack-plugin
export default {"header":"header-Tj9mvA","lead":"lead-wOsj1o","link":"link-Q064aE","person":"person-XBPbEI","sync":"sync-TEgX80"};